import React from 'react';
import styled from 'styled-components';

import { FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import SkypassFooterTermsAndConditions from '@ecp/fo/sites/skypass/components/footer/SkypassFooterTermsAndConditions';
import SkypassFooterBusinessInfo from '@ecp/fo/sites/skypass/components/footer/SkypassFooterBusinessInfo';
import SkypassFooterNotice from '@ecp/fo/sites/skypass/components/footer/SkypassFooterNotice';

export default function SkypassFooter() {
  return (
    <Container>
      <SkypassFooterNotice />
      <Spacing top={40} />
      <HorizontalDivider width={'100%'} />
      <SkypassFooterTermsAndConditions />
      <HorizontalDivider width={'100%'} />
      <SkypassFooterBusinessInfo />
      <Spacing top={20} />
    </Container>
  );
}

const Container = styled(FlexBoxColumn)`
  width: 100%;
  margin-top: 80px;
`;
